<template>
  <!-- Price guide of a listing's product, one line (lists, Échéances) -->
  <span v-if="cote && cote.median" class="cote-chip" :title="title"
    ><span class="cote-chip__label">{{ label }}</span>
    <strong>{{ yen(cote.median) }}</strong>
    <span v-if="gap !== null" :class="['cote-chip__gap', gapClass]">{{
      gapLabel
    }}</span></span
  >
</template>

<script>
import { computed } from "vue";

export const CONDITION_LABELS = {
  loose: "loose",
  boxed: "en boîte",
  new: "neuf",
  any: "tous états",
};

export const formatYen = (value) =>
  `${new Intl.NumberFormat("fr-FR", { maximumFractionDigits: 0 }).format(
    Number(value) || 0,
  )} ¥`;

export default {
  name: "CoteChip",
  props: {
    // Summary stored on the offer: { condition, median, count, name… }
    cote: { type: Object, default: null },
    // Current price of the listing (JPY), compared with the guide
    price: { type: [Number, String], default: null },
  },
  setup(props) {
    const label = computed(
      () => `Cote ${CONDITION_LABELS[props.cote?.condition] || ""}`,
    );
    const gap = computed(() => {
      const price = Number(props.price);
      const median = Number(props.cote?.median);
      if (!price || !median) return null;
      return Math.round(((price - median) / median) * 100);
    });
    const gapLabel = computed(() =>
      gap.value === 0
        ? "au prix de la cote"
        : `${gap.value > 0 ? "+" : "−"}${Math.abs(gap.value)} %`,
    );
    const gapClass = computed(() =>
      gap.value === null
        ? ""
        : gap.value <= -10
          ? "below"
          : gap.value >= 10
            ? "above"
            : "",
    );
    const title = computed(() =>
      props.cote
        ? `${props.cote.name || "Produit"} · ${props.cote.count} vente${
            props.cote.count > 1 ? "s" : ""
          } au Japon${
            gap.value !== null ? ` · prix actuel ${gapLabel.value}` : ""
          }`
        : "",
    );
    return { gap, gapClass, gapLabel, label, title, yen: formatYen };
  },
};
</script>

<style scoped>
.cote-chip {
  display: inline-flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: 2px 5px;
  color: #5d6a7c;
  font-size: 11px;
}
.cote-chip > * {
  white-space: nowrap;
}
.cote-chip strong {
  color: #26324a;
  font-weight: 800;
}
.cote-chip__gap {
  padding: 1px 5px;
  border-radius: 4px;
  background: #eef1f5;
  font-weight: 700;
}
.cote-chip__gap.below {
  background: #e7f6ef;
  color: #137551;
}
.cote-chip__gap.above {
  background: #fdf0ef;
  color: #b2423d;
}
</style>
